const toNullableNumber = (value) => {
  if (value === "" || value === null || value === undefined) return null;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const toNullableBoolean = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  if (value === true || value === "true") return true;
  if (value === false || value === "false") return false;
  return null;
};

export const buildApartmentSearchRequest = (transferId, filters = {}) => ({
  transferId,
  genderId: toNullableNumber(filters.genderId),
  ageRangeId: toNullableNumber(filters.ageRangeId),
  isAmea: toNullableBoolean(filters.isAmea),
});

export const formatIncompatibilityReasons = (reasons = []) => {
  const messages = reasons
    .map((reason) => reason?.message?.trim())
    .filter(Boolean);

  return messages.length > 0
    ? messages.join(" ")
    : "Το διαμέρισμα δεν συμφωνεί με τα χαρακτηριστικά του παιδιού.";
};
